import {
    GET_RBDM_LIST,GET_RBDM_FE, CLEAR_ALL, GET_RBDM_DASHBOARD_LIST
} from '../types/RbdmActivityType'

const initState = { rdbmList: [], fEList: [], onboardingActivity: {}, mandatoryCoarses: {}, certification: {}, 
preparingProspectList: {}, message: '', blockActivity: false, rbdmDashboardList: [] }

export const RdbmActivityReducer = (state = initState, action) => {
    switch (action.type) {
        case GET_RBDM_LIST:
            return {
                ...state,
                rdbmList: !action.error ? action.payload.jointImdCalls : state.rdbmList,
                onboardingActivity: !action.error ? action.payload.onboardingActivity : state.onboardingActivity,
                mandatoryCoarses: !action.error ? action.payload.mandatoryCoarses : state.mandatoryCoarses,
                certification: !action.error ? action.payload.certification : state.certification,
                preparingProspectList: !action.error ? action.payload.preparingProspectList : state.preparingProspectList,
                message: !action.error ? action.payload.message : state.message,
                blockActivity: !action.error ? action.payload.blockActivity : state.blockActivity
            }
        case GET_RBDM_FE:
            return {
                ...state,
                fEList: !action.error ? action.payload.list : state.rdbmList
            }
        case CLEAR_ALL:
            return {
                ...state,
                rdbmList: [],
                onboardingActivity: {},
                mandatoryCoarses: {},
                certification: {},
                preparingProspectList: {},
                message: '',
                blockActivity: false
            }
            case GET_RBDM_DASHBOARD_LIST:
                return {
                    ...state,
                    rbdmDashboardList: action.payload
                }            
        default:
            return state;
    }
}